import styled from 'styled-components'

import { font } from '~/styles/utils'

export const Container = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.div<{ $disabled: boolean }>`
  ${font('bold')};
  font-size: 14px;
  text-transform: none;
  color: ${({ $disabled, theme }) =>
    $disabled ? theme.color.text.disabled : theme.color.text.subdued};
`

export const SubLabel = styled.div<{ $disabled: boolean }>`
  font-size: 16px;
  text-transform: none;
  color: ${({ $disabled, theme }) =>
    $disabled ? theme.color.text.disabled : theme.color.text.default};

  && {
    .amp-button.inline {
      color: ${({ $disabled, theme }) =>
        $disabled ? theme.color.text.disabled : theme.color.text.button};
    }
  }
`

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
